// extracted by mini-css-extract-plugin
export default {"dark":"WhyDMPImportant_dark__7UDlH","light":"WhyDMPImportant_light__LNvmn"};